export enum Permission {
  IncentiveBudgetsView = 'incentive_budgets.view',
  IncentiveBudgetsModify = 'incentive_budgets.modify',
}
